module.exports = __webpack_public_path__ + "img/pzzx.19c6219c.svg";